import type { NavigationItem } from '@/data/types';
import navigationData from '@/data/navigation.json';

export function useNavigationData() {
  const navigationItems = navigationData as NavigationItem[];
  return { navigationItems, loading: false, error: null };
}